const WEB_BASE_URL = process.env.REACT_APP_WEB_URL || 'https://sosyal.media';

/**
 * Kullanıcı profil URL'ini oluşturur
 * @param username - Kullanıcı adı
 * @returns Profil URL'i
 */
export const getUserProfileUrl = (username: string): string => {
  const baseUrl = WEB_BASE_URL.endsWith('/')
    ? WEB_BASE_URL.slice(0, -1)
    : WEB_BASE_URL;
  return `${baseUrl}/profile/${username}`;
};
